import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';

import List from './List';

export default {
  list: List,
  icon: CategoryOutlinedIcon,
};
